import { VirtualScrollerDesignTokens } from '@primeuix/themes/aura/virtualscroller';

export const virtualScrollerTokens: VirtualScrollerDesignTokens = {
  loader: {
    mask: {
      background: '{content.background}',
      color: '{text.muted.color}',
    },
    icon: {
      size: '2rem',
    },
  },
};
